import Model from '../models/model';

const model = new Model({
	name: 'Transaction',
	api: 'BrokerTransaction',
	idProperty: 'id',
	defaultSort: 'CreatedDate DESC',
	disableAdd: true,
	disableDelete: true,
	formTitleField: 'EventType',
	showGridRefreshBtn: true,
	title: 'Transaction',
	columns: [
		{ field: 'EquipmentSerialNumber', header: 'SerialNumber', width: 200 },
		{ field: 'EventType', width: 150 },
		{ field: 'EventSource', width: 180 },
		{ field: 'Data', width: 500 },
		{ field: 'IsProcessed', width: 150, type: 'bool' },
		{ field: 'CreatedDate', width: 180, type: 'dateTime', isLocal: false },
		{ field: 'LastUpdateDate', width: 180, type: 'dateTime', isLocal: false }
	]
});

export default model.createFormBase();